// src/components/InspectionBooking.js
import React, { Component } from 'react';
import axios from 'axios';
import axiosInstance from "./axiosConfig";
import {
  Box, Button, Typography, TextField, Table, TableHead,
  TableRow, TableCell, TableBody, TablePagination,
  FormControl, InputLabel, CircularProgress,MenuItem,
  Dialog, DialogTitle, DialogContent, DialogActions, Checkbox,InputAdornment,Select
} from '@mui/material';
import dayjs from 'dayjs';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Snackbar } from "@mui/material";
const STATUS_LABELS = {
  1: 'New',
  2: 'Assigned',
  3: 'Completed',
  4: 'Not Interested',
  5: 'Postponed',
  6: 'Reassigned'
};
const getStatusLabel = status => STATUS_LABELS[status] || 'Unknown';
class InspectionBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookings: [],  snackbarOpen: false,
  snackbarMessage: "",
      totalItems: 0,searchPhoneEmail: '',
      page: 0,
      rowsPerPage: 5,
      searchPhone: '',
      searchEmail: '',
      searchDate: '',DCrole: localStorage.getItem("DCrole"),
  DCuserid: localStorage.getItem("DCuserid"),
      searchStatus: '',
      slots: [],
      assignDialogOpen: false,
      currentBooking: null,
      reassignMode: false,
      selectedDate: '',
      selectedSlot: '',
      unassignedStaff: [],
      selectedStaffId: '',
      loadingStaff: false,
      savingAssignment: false,
      errorMsg: '',
      selectedBookings: [],
      bulkStatus: ''
    };
  }
  componentDidMount() {
	    document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchBookings();
    this.fetchSlots();
  }
fetchBookings = () => {
  const { page, rowsPerPage, searchPhoneEmail, searchDate, searchStatus, DCrole, DCuserid } = this.state;
  const params = {
    page,
    limit: rowsPerPage,
    ...(searchPhoneEmail && { search: searchPhoneEmail }),
    ...(searchDate && { ib_date: searchDate }),
    ...(searchStatus && { status: searchStatus }),
  };
  if (DCrole === "3") {
    params.staff_id = DCuserid; 
  }
  axiosInstance.get(Serverurl + 'inspectionbooking/inspectiongetall', { params })
    .then(res => {
      const { bookings, totalCount } = res.data;
      this.setState({ bookings, totalItems: totalCount });
    })
    .catch(err => console.error("Error fetching bookings:", err));
};
  fetchSlots = () => {
    axiosInstance.get(Serverurl+"slotmanagement/slotmanagementall")
      .then(res => this.setState({ slots: res.data }));
  }
  fetchUnassignedStaff = (date, slotId) => {
    this.setState({ loadingStaff: true, errorMsg: '' });
    axiosInstance.get(Serverurl+"staffassign/unassignedstaff", {
      params: {
        date: dayjs(date).format('YYYY-MM-DD'),
        sl_id: slotId
      }
    })
      .then(res => {
        this.setState({ unassignedStaff: res.data, loadingStaff: false });
      });
  }
  handleChangePage = (_, newPage) => {
    this.setState({ page: newPage }, this.fetchBookings);
  }
  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, this.fetchBookings);
  }
  openAssignDialog = booking => {
    const isReassign = booking.sa_status === 5 || booking.sa_status === 2;
    this.setState({
      assignDialogOpen: true,
      currentBooking: booking,
      reassignMode: isReassign,
      selectedDate: isReassign ? '' : booking.ib_date,
      selectedSlot: isReassign ? '' : booking.ib_sl_id,
      selectedStaffId: '',
      unassignedStaff: [],
      errorMsg: '',
      loadingStaff: false
    }, () => {
      if (!isReassign) {
        this.fetchUnassignedStaff(booking.ib_date, booking.ib_sl_id);
      }
    });
  }
  closeAssignDialog = () => {
    this.setState({
      assignDialogOpen: false,
      currentBooking: null,
      reassignMode: false,
      selectedDate: '',
      selectedSlot: '',
      selectedStaffId: '',
      unassignedStaff: [],
      loadingStaff: false,
      savingAssignment: false,
      errorMsg: ''
    });
  }
  handleSelectStaff = event => {
    this.setState({ selectedStaffId: event.target.value });
  }
  handleSelectDate = event => {
    this.setState({ selectedDate: event.target.value, selectedSlot: '', unassignedStaff: [] });
  }
  handleSelectSlot = event => {
    const slotVal = event.target.value;
    this.setState({ selectedSlot: slotVal, selectedStaffId: '' }, () => {
      const { selectedDate } = this.state;
      if (selectedDate && slotVal) {
        this.fetchUnassignedStaff(selectedDate, slotVal);
      }
    });
  }
  saveAssignment = () => {
    if (!this.state.selectedStaffId) {
      this.setState({ errorMsg: 'Please select a staff member' });
      return;
    }
    if (this.state.reassignMode && (!this.state.selectedDate || !this.state.selectedSlot)) {
      this.setState({ errorMsg: 'Please select date and slot for reassignment' });
      return;
    }
    this.setState({ savingAssignment: true, errorMsg: '' });
    if (this.state.reassignMode) {
      axiosInstance.post(Serverurl+"staffassign/staffreassign", {
        sa_ib_id: this.state.currentBooking.ib_id,
        sa_cu_id: this.state.selectedStaffId,
        sa_date: this.state.selectedDate,
        sa_sl_id: this.state.selectedSlot
      })
        .then(() => {
this.showSnackbar("Reassigned successfully");
          this.closeAssignDialog();
          this.fetchBookings();
        })
    } else {
      axiosInstance.post(Serverurl+"staffassign/staffassigninsert", {
        sa_cu_id: this.state.selectedStaffId,
        sa_ib_id: this.state.currentBooking.ib_id,
        sa_status: 2
      })
        .then(() => {
this.showSnackbar("Assigned successfully");
          this.closeAssignDialog();
          this.fetchBookings();
        });
    }
  }
  handleBulkUpdate = () => {
    axiosInstance.post(Serverurl+"inspectionbooking/inspectionbookbulk-status-update", {
      ib_ids: this.state.selectedBookings,
      status: parseInt(this.state.bulkStatus, 10),
    })
      .then(() => {
        this.showSnackbar("Status updated successfully");
        this.setState({ selectedBookings: [], bulkStatus: '' });
        this.fetchBookings();
      });
  }
  updateStatus = (ib_id, newStatus) => {
    axiosInstance.post(Serverurl+"inspectionbooking/inspectionupdate-status", {
      ib_id,
      status: newStatus
    })
      .then(() => {
        this.showSnackbar("Status updated successfully");
       this.setState(prevState => ({
  bookings: prevState.bookings.map(b =>
    b.ib_id === ib_id ? { ...b, sa_status: newStatus, ib_status: newStatus } : b
  )
}));
      });
  }
  getStatusValue = (booking) => {
  if (booking.ib_status === 3 || booking.ib_status === 4) {
    return booking.ib_status;
  }
  // Otherwise, show the latest sa_status if exists
  if (booking.latestAssign && booking.latestAssign.length > 0) {
    return booking.latestAssign[0].sa_status;
  }
  // Fallback to ib_status
  return booking.ib_status;
};
showSnackbar = (msg) => {
  this.setState({
    snackbarOpen: true,
    snackbarMessage: msg
  });
};
  render() {
	  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    const { bookings,currentBooking,selectedBookings} = this.state;
    return (
	  	  <div className="maincontentDiv">
		  <Typography pt={2} pb={2} className="contentHeading" variant="h5">Inspection Bookings</Typography>
<Snackbar
  open={this.state.snackbarOpen}
  autoHideDuration={5000}
  onClose={() => this.setState({ snackbarOpen: false })}
  message={this.state.snackbarMessage}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
/>
            <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
         <Box sx={{
          display: 'flex',
          gap: 2,
          mb: 3,
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}>
            <Box  
			sx={{ paddingLeft:'12px', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>Name / Email / Phone</Typography>
            <TextField
              value={this.state.searchPhoneEmail}
              onChange={e => this.setState({ searchPhoneEmail: e.target.value })}
              size="small"
              placeholder="Search"
			  InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
            />
          </Box>
		   <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>Date</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    value={this.state.searchDate ? dayjs(this.state.searchDate) : null}
    onChange={(newVal) => {
      const formatted = newVal ? dayjs(newVal).format('YYYY-MM-DD') : '';
      this.setState({ searchDate: formatted });
    }}
    format="DD-MM-YYYY"
    slotProps={{
      textField: {
        size: "small",
        placeholder: "Search",
        InputProps: {
          startAdornment: (
            <InputAdornment position="start">
              <img src={searchIcon} alt="search" />
            </InputAdornment>
          )
        }
      }
    }}
  />
</LocalizationProvider>
</Box>
		  <Box sx={{ display: "flex", flexDirection: "column", width: "230px"  }}>
    <Typography sx={{ mb: 0.5 }} variant="body1">Status</Typography>
   <Select   
displayEmpty   
            size= "small"                   
       value={this.state.searchStatus}
         onChange={e => this.setState({ searchStatus: e.target.value })}
      >
        <MenuItem value="">All
        </MenuItem>
        <MenuItem value="1">New</MenuItem>
        <MenuItem value="2">Assigned</MenuItem>
        <MenuItem value="3">Completed</MenuItem>
        <MenuItem value="4">Not Interested</MenuItem>
        {/*<MenuItem value="5">Postponed</MenuItem>*/}
        <MenuItem value="6">Reassigned</MenuItem>
      </Select>
  </Box>
            <Button size="small" variant="contained" style={{marginTop:25}} className="frmPrimarybtn" onClick={() => this.setState({ page: 0 }, this.fetchBookings)}>Search</Button>
          </Box>
{this.state.selectedBookings.length > 0 && (
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
    <FormControl size="small" sx={{ ml:1,minWidth: 180 }}>
      <InputLabel>Update Status</InputLabel>
      <Select
        label="Update Status"
        value={this.state.bulkStatus}
        onChange={(e) => this.setState({ bulkStatus: e.target.value })}
      >
        <MenuItem value=""><em>Select Status</em>
        </MenuItem>
        <MenuItem value="3">Completed</MenuItem>
        <MenuItem value="4">Not Interested</MenuItem>
      </Select>
    </FormControl>
    <Button
	size="small"
	sx={{mr:1}}
      variant="contained"
      disabled={!this.state.bulkStatus}
      onClick={this.handleBulkUpdate}
      className="frmPrimarybtn"
    >
      Apply
    </Button>
  </Box>
)}
        </Box>
        {/* Table */}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={this.state.selectedBookings.length > 0 && this.state.selectedBookings.length < this.state.bookings.length}
                  checked={this.state.bookings.length > 0 && this.state.selectedBookings.length === this.state.bookings.length}
                  onChange={(e) => {
                    this.setState({
                      selectedBookings: e.target.checked ? bookings.map(b => b.ib_id) : [],
                    });
                  }}
                />
              </TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Address</TableCell>
              <TableCell width={130}>Date</TableCell>
			  <TableCell>Service</TableCell>
              <TableCell>Slot</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Assign</TableCell>
            </TableRow>
          </TableHead>
         <TableBody>
  {this.state.bookings.length === 0 ? (
    <TableRow>
      <TableCell colSpan={10} align="center">No requests found.</TableCell>
    </TableRow>
  ) : (
    this.state.bookings.map((booking) => {
      const displayStatus = this.getStatusValue(booking); 
      const isChecked = this.state.selectedBookings.includes(booking.ib_id);
      return (
        <TableRow key={booking.ib_id}>
          <TableCell padding="checkbox">
            <Checkbox
              checked={isChecked}
              onChange={() => {
                const newSelection = isChecked
                  ? this.state.selectedBookings.filter((id) => id !== booking.ib_id)
                  : [...this.state.selectedBookings, booking.ib_id];
                this.setState({ selectedBookings: newSelection });
              }}
            />
          </TableCell>
		  <TableCell>
  {booking.customerInfo?.[0]?.cu_name || "Customer"}
</TableCell>
          <TableCell>{booking.ib_phoneno}</TableCell>
          <TableCell>{booking.ib_email}</TableCell>
          <TableCell>{booking.ib_address}</TableCell>
          <TableCell>{dayjs(booking.ib_date).format('DD-MM-YYYY')}</TableCell>
		  <TableCell>
  {booking.ib_sm_id
    ? (booking.serviceName || "N/A")
    : "Inspection"}
</TableCell>
          <TableCell>{booking.slotInfo?.[0]?.sl_title || 'N/A'}</TableCell>
          <TableCell>{getStatusLabel(displayStatus)}</TableCell>
          <TableCell>
            {/* Assign Button for New */}
            {displayStatus === 1 && (
              <Button
                variant="contained"
                size="small"
                onClick={() => this.openAssignDialog(booking)}
              >
                Assign
              </Button>
            )}
            {/* Buttons for Assigned */}
{displayStatus !== 3 && displayStatus !== 4 && displayStatus !== 1 && (
              <>
                <Button
				sx={{mt:0.5}}
                  variant="contained"
                  size="small"
                  color="success"
                  onClick={() => this.updateStatus(booking.ib_id, 3)}
                  sx={{ mr: 1 }}
                >
                  Completed
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  onClick={() => this.updateStatus(booking.ib_id, 4)}
                  sx={{ mr: 1 , mt:0.5}}
                >
                  Not Interested
                </Button>	
				{displayStatus === 2 && localStorage.getItem('DCrole') === "1" && (
                <Button
				sx={{mt:0.5}}
                  variant="contained"
                  size="small"
                  onClick={() => this.openAssignDialog(booking)}
                >
                  Reassign
                </Button>
				)}
              </>
            )}
            {/* Reassign for Postponed */}
            {displayStatus === 5 && localStorage.getItem('DCrole') === "1" && (
              <Button
				sx={{mt:0.5}}
                variant="contained"
                size="small"
                onClick={() => this.openAssignDialog(booking)}
              >
                Reassign
              </Button>
            )}
          </TableCell>
        </TableRow>
      );
    })
  )}
</TableBody>
        </Table>
        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 20]}
        />
        {/* Dialog */}
        <Dialog open={this.state.assignDialogOpen} onClose={this.closeAssignDialog} fullWidth maxWidth="sm">
          <DialogTitle>{this.state.reassignMode ? 'Reassign Staff' : 'Assign Staff'}</DialogTitle>
          <DialogContent>
            {this.state.reassignMode && (
  <>
  <Box mt={2}></Box>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
	  disablePast
        label="Select Date"
        value={this.state.selectedDate ? dayjs(this.state.selectedDate) : null}
        onChange={(newVal) => {
          const formatted = newVal ? dayjs(newVal).format("YYYY-MM-DD") : "";
          this.setState({
            selectedDate: formatted,
            selectedSlot: "",
            unassignedStaff: []
          });
        }}
        format="DD-MM-YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            sx: { mb: 2 }
          }
        }}
      />
    </LocalizationProvider>
    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
      <InputLabel>Select Slot</InputLabel>
      <Select
        label="Select Slot"
        value={this.state.selectedSlot}
        onChange={(e) => {
          const slotVal = e.target.value;
          this.setState({ selectedSlot: slotVal, selectedStaffId: "" }, () => {
            if (this.state.selectedDate && slotVal) {
              this.fetchUnassignedStaff(this.state.selectedDate, slotVal);
            }
          });
        }}
      >
        <MenuItem value="">
          <em>Select Slot</em>
        </MenuItem>
        {this.state.slots.map((slot) => (
          <MenuItem key={slot.sl_id} value={slot.sl_id}>
            {slot.sl_title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
)}
         {!this.state.reassignMode && (
  <Typography gutterBottom sx={{ pl:1 ,mb:1,mt: 2 }}>
    Date: {currentBooking ? dayjs(currentBooking.ib_date).format('DD-MM-YYYY') : ''} ,{" "}
    {currentBooking?.slotInfo?.[0]?.sl_title || 'N/A'}
  </Typography>
)}
            {this.state.loadingStaff && (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                <CircularProgress />
              </Box>
            )}
            {!this.state.loadingStaff && ((!this.state.reassignMode) || (this.state.reassignMode && this.state.selectedSlot)) && (
               <FormControl fullWidth size="small" sx={{ mb: 2 }}>
    <InputLabel>Select Staff</InputLabel>
    <Select
      label="Select Staff"
      value={this.state.selectedStaffId}
      onChange={this.handleSelectStaff}
    >
      {this.state.unassignedStaff.length === 0 ? (
        <MenuItem value="">
          <em>No staff available</em>
        </MenuItem>
      ) : (
        this.state.unassignedStaff.map((staff) => (
          <MenuItem key={staff.cu_id} value={staff.cu_id}>
            {staff.cu_name}
          </MenuItem>
        ))
      )}
    </Select>
  </FormControl>
            )}
            {this.state.errorMsg && <Typography color="error" sx={{ mt: 2 }}>{this.state.errorMsg}</Typography>}
          </DialogContent>
          <DialogActions  sx={{ justifyContent: 'space-between' }}>
            <Button className="frmSecondarybtn" onClick={this.closeAssignDialog} disabled={this.state.savingAssignment}>Cancel</Button>
            <Button
              variant="contained"
			   className="frmPrimarybtn"
              onClick={this.saveAssignment}
              disabled={this.state.savingAssignment || this.state.loadingStaff}
            >
              {this.state.savingAssignment ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>		
      </div>
    );
  }
}
export default InspectionBooking;